import { useDocumentHead } from "../../lib/document-head.ts";
import { useHomeMotion } from "./hooks/useHomeMotion.ts";
import { useScrollToHash } from "./hooks/useScrollToHash.ts";
import { Nav } from "./components/Nav.tsx";
import { Hero } from "./components/Hero.tsx";
import { LandSeaAir } from "./components/LandSeaAir.tsx";
import { FeaturedEvents } from "./components/FeaturedEvents.tsx";
import { DiscoverNearYou } from "./components/DiscoverNearYou.tsx";
import { Community } from "./components/Community.tsx";
import { HostEvents } from "./components/HostEvents.tsx";
import { Newsletter } from "./components/Newsletter.tsx";
import { SiteFooter } from "./components/SiteFooter.tsx";
import { launchFlags } from "./data.ts";

/**
 * events.restomag.com marketing homepage — recreated from the Claude Design handoff
 * ("RestoMag Events.dc.html"), default variants: Hero A (cinematic) + Land·Sea·Air A (editorial).
 */
export function HomeScreen() {
  const { scrolled } = useHomeMotion();
  useScrollToHash();

  // Public marketing page — indexable, with a brand-appropriate title (overrides the static default).
  useDocumentHead({
    title: "RestoMag Events — The home of enthusiast events · Land, Sea & Air",
    description:
      "Discover the best automotive, aviation and marine events across North America — and the people, machines and culture behind every one.",
    robots: "index",
  });

  return (
    <div className="overflow-x-hidden bg-ink font-archivo text-white">
      <Nav scrolled={scrolled} />
      <span id="top" />
      <Hero />
      {launchFlags.landSeaAir && <LandSeaAir />}
      <FeaturedEvents />
      {launchFlags.discover && <DiscoverNearYou />}
      {launchFlags.community && <Community />}
      <HostEvents />
      <Newsletter />
      <SiteFooter />
    </div>
  );
}
